import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';


class RoleService {
    createRole(role) {
        if (role === null || role === undefined) {
            return new Promise((resolve, reject) => {
                reject('Data is empty');
            });
        } else {
            return axios.post(Config.apiBasePath + '/saveRole', role,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        ...authHeader() // Add your authentication headers here if needed
                    }
                });
        }

    }

    fetchRole() {

        return axios.get(Config.apiBasePath + '/getRoles', {
            headers: {
                ...authHeader()
            }
        });
    }

    async updateRole(role) {

        if (role === null || role === undefined) {
            return new Promise((resolve, reject) => {
                reject('Data is empty');
            });
        } else {
            return await axios.post(Config.apiBasePath + '/updateRole', role,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        ...authHeader() // Add your authentication headers here if needed
                    }
                });
        }

    }

    deleteRole(param) {
        return axios.get(Config.apiBasePath + '/deleteRole', {
            params: param,
            headers: {
                ...authHeader()
            }
        });
    }
}

export default new RoleService();